module.exports = __webpack_public_path__ + "img/activity6.69fde6de.png";